import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Typography, Row, Col, Form, Table } from "antd";
import { changeFormatFulldate } from "../../../../../utils/formatdate";

const { Text, Title } = Typography;

class WelfareListStudyPaymentSecHistory extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
    columns: [
      // {
      //   title: "ลำดับ",
      //   dataIndex: "noTable",
      //   align: "center",
      //   render: (item, record, index) => <span>{index+1}</span>,
      // },
      {
        title: "วันที่ดำเนินรายการ",
        dataIndex: "studyFeeHistoryActionDatetime",
        align: "center",
        render: (item, record, index) => <span>{item ? changeFormatFulldate(item) : "-"}</span>,
      },
      {
        title: "ผู้ดำเนินรายการ",
        dataIndex: "studyFeeHistoryActionBy",
        align: "center",
        render: (item, record, index) => (
            <span>{item}</span>
        ),
      },
      {
        title: "สถานะ",
        dataIndex: "studyFeeHistoryStatus",
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "ดำเนินการ",
        dataIndex: "studyFeeHistoryAction",
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
      {
        title: "หมายเหตุ",
        dataIndex: "studyFeeHistoryRemark",
        align: "center",
        render: (item, record, index) => <span>{item ? item : "-"}</span>,
      },
    ],
  };

  async componentDidMount() {}

  render() {
    const { match, rawData } = this.props;
    const { loadingFullpage, columns } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <>
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2"
        >
          <Col md={24} className="mb-3">
          <Text className="color-red">
            <span style={{ fontSize: "18px" }}>
            ประวัติดำเนินการ
              </span></Text>

          </Col>

          <Col md={24} className="mb-2">
            <Form.Item className="mb-0" />
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={rawData}
              pagination={false}
            />
          </Col>
        </Row>
      </>
    );
  }
}

WelfareListStudyPaymentSecHistory.defaultProps = {
  autoFocus: false,
};

WelfareListStudyPaymentSecHistory.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListStudyPaymentSecHistory = Form.create()(
  WelfareListStudyPaymentSecHistory
);

export default withApollo(WrappedWelfareListStudyPaymentSecHistory);
